import { useState, useCallback, useEffect } from "react";
import { BetSlipMode } from "../types/enums";

interface UseStakesProps {
  selections: IBetSlipSelection[];
  mode: BetSlipMode;
}

export const useStakes = ({ selections, mode }: UseStakesProps) => {
  const [individualStakes, setIndividualStakes] = useState<{
    [key: string]: number;
  }>({});
  const [globalStake, setGlobalStake] = useState<number>(0);

  useEffect(() => {
    const currentKeys = selections.map((s) => s.key);
    setIndividualStakes((prev) => {
      const filtered: { [key: string]: number } = {};
      currentKeys.forEach((key) => {
        if (prev[key] !== undefined) {
          filtered[key] = prev[key];
        }
      });
      return filtered;
    });
  }, [selections]);

  useEffect(() => {
    if (mode === BetSlipMode.Single) {
      resetStakes();
    }
  }, [mode]);

  const updateStake = useCallback(
    (selectionKey: string, stake: number) => {
      setIndividualStakes((prev) => ({
        ...prev,
        [selectionKey]: stake,
      }));

      if (mode === BetSlipMode.Single) {
        setGlobalStake(0);
      }
    },
    [mode],
  );

  const updateGlobalStake = useCallback(
    (stake: number) => {
      setGlobalStake(stake);

      if (mode === BetSlipMode.Single) {
        setIndividualStakes(() => {
          const newStakes: { [key: string]: number } = {};
          selections.forEach((selection) => {
            newStakes[selection.key] = stake;
          });
          return newStakes;
        });
      }
    },
    [mode, selections],
  );

  const resetStakes = useCallback(() => {
    setIndividualStakes({});
    setGlobalStake(0);
  }, []);

  return {
    stakes: individualStakes,
    globalStake,
    updateStake,
    updateGlobalStake,
    resetStakes,
  };
};
